export const theme = {
  fontPrimary: `'Nunito', sans-serif`,
  fontSecondary: `'Nunito', sans-erif`,
  primaryColor: "#154734",
  secondaryColor: "#691017",
  textColor: "#333",
  neutralDark: "#000",
  neutralLight: "#f3f3f3",
  neutralLight2: "#ececec",
  neurtralLighter: "rgba(255,255,255,0.2)",
  themeWhite: "#FFF",
  themeDark: "#04150C",
  accentColor: "#FFD03E",
  transitionEase: "all 0.2s linear",
  transitionEase1: "all 0.5s ease-in-out",
  shadow: "5px 5px 20px 0 rgb(0 0 0 / 6%)",
}
